import { useFeatureFlags } from "@/configs/featureFlag";
import { isLocalHost } from "@/utils/environment";

/**
 * 法人マスタ（R.E.DATA Plus）の導線・ルートを表示するかを返す。
 * LaunchDarkly のフラグキーは `corporate-master`（SDK上は camelCase の `corporateMaster`）。
 * ローカル（localhost）では確認用に常に表示する。ルート（App）とメニュー（SideMenu/Mypage）は
 * 必ずこのフックで判定し、表示の不整合を防ぐ。
 * @returns 法人マスタを表示する場合は true
 */
export const useCorporateMasterEnabled = (): boolean => {
  const { corporateMaster } = useFeatureFlags();
  return corporateMaster === true || isLocalHost();
};
